<template>
	<div id="app">
		<router-view />
	</div>
	<!-- <div>
		<div class="content-box">
		</div>
		<div class="content-box-1">
			<div class="content-box-title">四川省劳动与实践教育管理平台-课程大赛报名通道</div>
			<div class='content-view'>
				<keep-alive>
					　　<router-view v-if="$route.meta.keepAlive"></router-view>
				</keep-alive>
				<router-view v-if="!$route.meta.keepAlive"></router-view>
			</div> -->
			<!-- <div class="content-box-footer">
				<div>
					主办单位：新华文轩
				</div>
				<div>
					技术支持：存时科技
				</div>
			</div> -->
		<!-- </div>
	</div> -->

</template>

<script>
	export default {
		data() {
			return {

			}
		},
		mounted() {
			if (!sessionStorage.getItem('competition_course_poster_id')) {
				// 不存在审核配置
				let arr = window.location.pathname.split('/')
				let province_code = arr[arr.length - 2],
						competition_course_poster_id = arr[arr.length - 1]
				sessionStorage.setItem('competition_course_poster_id', competition_course_poster_id)
				console.log('province_code', province_code)
				if (province_code == 360000) {
					// 江西
					sessionStorage.setItem('province_name', 'jiangxi');
				} else if (province_code == 510000) {
					// 四川
					sessionStorage.setItem('province_name', 'sichuan');
				} else if (province_code == 110000) {
					// 北京
					sessionStorage.setItem('province_name', 'beijing');
				} else if (province_code == 410000) {
					// 河南
					sessionStorage.setItem('province_name', 'henan');
				} else if (province_code == 320000) {
					// 江苏
					sessionStorage.setItem('province_name', 'jiangsu');
				} else if (province_code == 460000) {
					// 海南
					sessionStorage.setItem('province_name', 'hainan');
				} else if (province_code == 350000) {
					// 福建
					sessionStorage.setItem('province_name', 'fujian');
				} else if (province_code == 440000) {
					// 广东
					sessionStorage.setItem('province_name', 'guangdong');
				} else if (province_code == 340000) {
					// 安徽
					sessionStorage.setItem('province_name', 'anhui');
				} else if (province_code == 650000) {
					// 新疆
					sessionStorage.setItem('province_name', 'xinjiang');
				} else if (province_code == 140000) {
					// 山西
					sessionStorage.setItem('province_name', 'shanxi');
				}
				this.$router.push({
					path: '/'
				})
			}
		}
	}
</script>

<style lang="scss">
	$--color-primary: var(--el-color-primary) !default;
	@import "assets/css/util.css";
	// @import "assets/css/comment.css";
	// @import "assets/css/button.css";
	// @import "assets/css/them.css";
	// @import "assets/theme/theme.scss";
</style>